module.exports = __webpack_public_path__ + "media/images/talent/story-01-cd8fe23107850ca3a1a396b731363f3c.png";